<ng-container *transloco="let t; prefix: 'fuelPerformance'">
<div class="dashboard-top-section d-flex align-items-center justify-content-between">
    <h1>{{ t('title') }}</h1>

    <div class="search-menu-lists d-flex">
        <div class="searchlist">
            <img src="assets/images-fuel/searchIcon.svg" alt="search-icon" />
            <input type="text" [placeholder]="t('filters.searchPlaceholder')" />

            <div class="common-filter common-dropdown-checkbox">
                <div class="common-drop-down dropdown">
                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        <img src="assets/images-fuel/filterIocn.svg" alt="filterIocn" />
                    </button>

                    <ul class="dropdown-menu dropdown-menu-end checkbox-wrapper" aria-labelledby="dropdownMenuButton1"
                        (click)="buttonMenuClick($event)">
                        <li>
                            <div>
                                <label class="parent-check-box">
                                    <input type="checkbox" id="parent-task" />
                                    <span>{{ t('accountTree.gtInternals') }}</span>
                                </label>
                                <div class="task-group">
                                    <label>
                                        <input type="checkbox" id="child-task-1" />
                                        <span>{{ t('accountTree.installers') }}</span>
                                    </label>
                                    <label>
                                        <input type="checkbox" id="child-task-2" />
                                        <span>{{ t('accountTree.sales') }}</span>
                                    </label>
                                    <label>
                                        <input type="checkbox" id="child-task-3" />
                                        <span>{{ t('accountTree.customers') }}</span>
                                    </label>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div>
                                <label class="parent-check-box">
                                    <input type="checkbox" id="parent-task" />
                                    <span>{{ t('accountTree.gtSouthAfrica') }}</span>
                                </label>
                                <div class="task-group">
                                    <label>
                                        <input type="checkbox" id="child-task-1" />
                                        <span>{{ t('accountTree.client1') }}</span>
                                    </label>
                                    <div class="task-group-lists">
                                        <label>
                                            <input type="checkbox" id="child-task-1" />
                                            <span>{{ t('accountTree.local') }}</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" id="child-task-2" />
                                            <span>{{ t('accountTree.crossBorder') }}</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" id="child-task-3" />
                                            <span>{{ t('accountTree.shortDistance') }}</span>
                                        </label>
                                    </div>
                                    <label>
                                        <input type="checkbox" id="child-task-2" />
                                        <span>{{ t('accountTree.client2') }}</span>
                                    </label>
                                    <label>
                                        <input type="checkbox" id="child-task-3" />
                                        <span>{{ t('accountTree.client3') }}</span>
                                    </label>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div>
                                <label class="parent-check-box">
                                    <input type="checkbox" id="parent-task" />
                                    <span>{{ t('accountTree.gtSouthAfrica') }}</span>
                                </label>
                                <div class="task-group">
                                    <label>
                                        <input type="checkbox" id="child-task-1" />
                                        <span>{{ t('accountTree.maputo') }}</span>
                                    </label>
                                    <label>
                                        <input type="checkbox" id="child-task-2" />
                                        <span>{{ t('accountTree.pemba') }}</span>
                                    </label>
                                    <label>
                                        <input type="checkbox" id="child-task-3" />
                                        <span>{{ t('accountTree.nampula') }}</span>
                                    </label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="datelisting">
            <div class="common-drop-down dropdown">
                <app-date-filter [filter]="utilizationDateFilter" [isButtonIntervalSelector]="false"
                    [disabledIntervals]="disabledIntervals" [disableCustomDateSelector]="false"
                    [defaultInterval]="defaultInterval" (filterChanged)="onUtilizationDateFilterChange($event)">
                </app-date-filter>
            </div>
        </div>

        <div class="export-listing">
            <div class="common-drop-down dropdown">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    {{ t('export.label') }} <i><img src="./assets/images-fuel/downloadIcon.svg" alt="export-icon" /></i>
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <li><a class="dropdown-item">{{ t('export.asPdf') }}</a></li>
                    <li><a class="dropdown-item">{{ t('export.asCsv') }}</a></li>
                    <li><a class="dropdown-item">{{ t('export.sendViaEmail') }}</a></li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="cmn_tabWrap">
    <div class="cmn_tabWrapUl">
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
                    type="button" role="tab" aria-controls="pills-home" aria-selected="true">{{ t('tabs.fuelLosses') }}</button>
            </li>
            <li class="nav-item" role="presentation" class="middileTab">
                <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile"
                    type="button" role="tab" aria-controls="pills-profile" aria-selected="false">{{ t('tabs.fuelConsumption') }}</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact"
                    type="button" role="tab" aria-controls="pills-contact" aria-selected="false">{{ t('tabs.fuelFillUps') }}</button>
            </li>
        </ul>
    </div>

    <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
            <div class="row performance_row">
                <div class="col-md-6 col-xs-12 performance_col">
                    <!-- <app-common-table [modalType]="'vehicale-highest-fuel'" /> -->
                    <div class="performence-table">
                        <div class="d-flex align-items-center justify-content-between table-top-options">
                          <h3>{{ t('sections.vehiclesHighestFuelLosses') }}</h3>
                          <div class="common-drop-down dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {{ t('sort.bestToWorst') }}
                              <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                              <li><a class="dropdown-item">{{ t('sort.bestToWorst') }}</a></li>
                              <li><a class="dropdown-item">{{ t('sort.worstToBest') }}</a></li>
                            </ul>
                          </div>
                        </div>
                      
                        <div class="main-table fuel-table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="vehicle">{{ t('table.vehicles') }}</th>
                                <th class="fuel-loss">
                                  {{ t('table.fuelLosses') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="last-month">
                                  {{ t('table.fromLastMonth') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="driving-time">
                                  {{ t('table.drivingTime') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 1 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 65%" aria-valuenow="65" aria-valuemin="0"
                                      aria-valuemax="100">
                                      1000
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 2 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0"
                                      aria-valuemax="100">
                                      800
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="decrease-txt">
                                    -4% <i><img src="assets/images-fuel/decreaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 3 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 57%" aria-valuenow="57" aria-valuemin="0"
                                      aria-valuemax="100">
                                      700
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="decrease-txt">
                                    -4% <i><img src="assets/images-fuel/decreaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 54%" aria-valuenow="54" aria-valuemin="0"
                                      aria-valuemax="100">
                                      600
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="decrease-txt">
                                    -4% <i><img src="assets/images-fuel/decreaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 49%" aria-valuenow="49" aria-valuemin="0"
                                      aria-valuemax="100">
                                      400
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      
                        <div class="table-btm-options">
                          <button class="common-button">{{ t('actions.viewAll') }}</button>
                        </div>
                      </div>
                </div>
                <div class="col-md-6 col-xs-12 performance_col">
                    <!-- <app-common-table [modalType]="'location-highest-fuel'" /> -->
                    <div class="performence-table">
                        <div class="d-flex align-items-center justify-content-between table-top-options">
                          <h3>{{ t('sections.locationHighestFuelLosses') }}</h3>
                          <div class="common-drop-down dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {{ t('sort.bestToWorst') }}
                              <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                              <li><a class="dropdown-item">{{ t('sort.bestToWorst') }}</a></li>
                              <li><a class="dropdown-item">{{ t('sort.worstToBest') }}</a></li>
                            </ul>
                          </div>
                        </div>
                        <div class="main-table fuel-table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="vehicle">{{ t('table.vehicles') }}</th>
                                <th class="fuel-loss">
                                  {{ t('table.fuelLosses') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="last-month">
                                  {{ t('table.fromLastMonth') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="driving-time">
                                  {{ t('table.drivingTime') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 1 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 65%" aria-valuenow="65" aria-valuemin="0"
                                      aria-valuemax="100">
                                      1000
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 2 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0"
                                      aria-valuemax="100">
                                      800
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 3 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 57%" aria-valuenow="57" aria-valuemin="0"
                                      aria-valuemax="100">
                                      700
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 54%" aria-valuenow="54" aria-valuemin="0"
                                      aria-valuemax="100">
                                      600
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 49%" aria-valuenow="49" aria-valuemin="0"
                                      aria-valuemax="100">
                                      400
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="table-btm-options">
                          <button class="common-button">{{ t('actions.viewAll') }}</button>
                        </div>
                      </div>
                </div>
                <div class="col-md-6 col-xs-12 performance_col">
                    <!-- <app-common-table [modalType]="'driver-highest-fuel'" /> -->
                    <div class="performence-table">
                        <div class="d-flex align-items-center justify-content-between table-top-options">
                          <h3>{{ t('sections.driverHighestFuelLosses') }}</h3>
                          <div class="common-drop-down dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {{ t('sort.bestToWorst') }}
                              <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                              <li><a class="dropdown-item">{{ t('sort.bestToWorst') }}</a></li>
                              <li><a class="dropdown-item">{{ t('sort.worstToBest') }}</a></li>
                            </ul>
                          </div>
                        </div>
                        <div class="main-table fuel-table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="vehicle">{{ t('table.vehicles') }}</th>
                                <th class="fuel-loss">
                                  {{ t('table.fuelLosses') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="last-month">
                                  {{ t('table.fromLastMonth') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="driving-time">
                                  {{ t('table.drivingTime') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 1 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 65%" aria-valuenow="65" aria-valuemin="0"
                                      aria-valuemax="100">
                                      1000
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 2 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0"
                                      aria-valuemax="100">
                                      800
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 3 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 57%" aria-valuenow="57" aria-valuemin="0"
                                      aria-valuemax="100">
                                      700
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 54%" aria-valuenow="54" aria-valuemin="0"
                                      aria-valuemax="100">
                                      600
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 49%" aria-valuenow="49" aria-valuemin="0"
                                      aria-valuemax="100">
                                      400
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="table-btm-options">
                          <button class="common-button">{{ t('actions.viewAll') }}</button>
                        </div>
                      </div>
                </div>
                <div class="col-md-6 col-xs-12 performance_col">
                    <!-- <app-common-table [modalType]="'most-improved-vehicles'" /> -->
                    <div class="performence-table">
                        <div class="d-flex align-items-center justify-content-between table-top-options">
                          <h3>{{ t('sections.mostImprovedVehicles') }}</h3>
                          <div class="common-drop-down dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {{ t('sort.bestToWorst') }}
                              <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                              <li><a class="dropdown-item">{{ t('sort.bestToWorst') }}</a></li>
                              <li><a class="dropdown-item">{{ t('sort.worstToBest') }}</a></li>
                            </ul>
                          </div>
                        </div>
                      
                        <div class="main-table fuel-table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="vehicle">{{ t('table.vehicles') }}</th>
                                <th class="fuel-loss">
                                  {{ t('table.fuelLosses') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="last-month">
                                  {{ t('table.fromLastMonth') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="driving-time">
                                  {{ t('table.drivingTime') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 1 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 65%" aria-valuenow="65"
                                      aria-valuemin="0" aria-valuemax="100">
                                      1000
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 2 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 60%" aria-valuenow="60"
                                      aria-valuemin="0" aria-valuemax="100">
                                      800
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 3 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 57%" aria-valuenow="57"
                                      aria-valuemin="0" aria-valuemax="100">
                                      700
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 54%" aria-valuenow="54"
                                      aria-valuemin="0" aria-valuemax="100">
                                      600
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 49%" aria-valuenow="49"
                                      aria-valuemin="0" aria-valuemax="100">
                                      400
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      
                        <div class="table-btm-options">
                          <button class="common-button">{{ t('actions.viewAll') }}</button>
                        </div>
                      </div>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
            <div class="row performance_row">
                <div class="col-md-6 col-xs-12 performance_col">
                    <!-- <app-common-table [modalType]="'fuelConsumptionOne'" /> -->
                    <div class="performence-table">
                        <div class="d-flex align-items-center justify-content-between table-top-options">
                          <h3>{{ t('sections.vehiclesHighestFuelConsumption') }}</h3>
                          <div class="common-drop-down dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {{ t('sort.bestToWorst') }}
                              <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                              <li><a class="dropdown-item">{{ t('sort.bestToWorst') }}</a></li>
                              <li><a class="dropdown-item">{{ t('sort.worstToBest') }}</a></li>
                            </ul>
                          </div>
                        </div>
                      
                        <div class="main-table fuel-table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="vehicle">{{ t('table.vehicles') }}</th>
                                <th class="fuel-loss">
                                  {{ t('table.fuel') }} <br /> {{ t('table.consumptionKmL') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="last-month">
                                  {{ t('table.distance') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="driving-time">
                                  {{ t('table.drivingTime') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                              </tr>
                            </thead>
                      
                            <tbody>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 1 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 65%" aria-valuenow="65" aria-valuemin="0"
                                      aria-valuemax="100">
                                      1000
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 2 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0"
                                      aria-valuemax="100">
                                      800
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="decrease-txt">
                                    -4% <i><img src="assets/images-fuel/decreaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 3 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 57%" aria-valuenow="57" aria-valuemin="0"
                                      aria-valuemax="100">
                                      700
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="decrease-txt">
                                    -4% <i><img src="assets/images-fuel/decreaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 54%" aria-valuenow="54" aria-valuemin="0"
                                      aria-valuemax="100">
                                      600
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="decrease-txt">
                                    -4% <i><img src="assets/images-fuel/decreaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 49%" aria-valuenow="49" aria-valuemin="0"
                                      aria-valuemax="100">
                                      400
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      
                        <div class="table-btm-options">
                          <button class="common-button">{{ t('actions.viewAll') }}</button>
                        </div>
                      </div>
                </div>
                <div class="col-md-6 col-xs-12 performance_col">
                    <!-- <app-common-table [modalType]="'fuelConsumptionTwo'" /> -->
                    <div class="performence-table">
                        <div class="d-flex align-items-center justify-content-between table-top-options">
                          <h3>{{ t('sections.routesHighestFuelConsumption') }}</h3>
                          <div class="common-drop-down dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {{ t('sort.bestToWorst') }}
                              <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                              <li><a class="dropdown-item">{{ t('sort.bestToWorst') }}</a></li>
                              <li><a class="dropdown-item">{{ t('sort.worstToBest') }}</a></li>
                            </ul>
                          </div>
                        </div>
                      
                        <div class="main-table fuel-table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="vehicle">{{ t('table.vehicles') }}</th>
                                <th class="fuel-loss">
                                  {{ t('table.fuel') }} <br /> {{ t('table.consumptionKmL') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="last-month">
                                  {{ t('table.distance') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="driving-time">
                                  {{ t('table.drivingTime') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                              </tr>
                            </thead>
                      
                            <tbody>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 1 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 65%" aria-valuenow="65" aria-valuemin="0"
                                      aria-valuemax="100">
                                      1000
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 2 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0"
                                      aria-valuemax="100">
                                      800
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 3 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 57%" aria-valuenow="57" aria-valuemin="0"
                                      aria-valuemax="100">
                                      700
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 54%" aria-valuenow="54" aria-valuemin="0"
                                      aria-valuemax="100">
                                      600
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 49%" aria-valuenow="49" aria-valuemin="0"
                                      aria-valuemax="100">
                                      400
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      
                        <div class="table-btm-options">
                          <button class="common-button">{{ t('actions.viewAll') }}</button>
                        </div>
                      </div>
                </div>
                <div class="col-md-6 col-xs-12 performance_col">
                    <!-- <app-common-table [modalType]="'fuelConsumptionThree'" /> -->
                    <div class="performence-table">
                        <div class="d-flex align-items-center justify-content-between table-top-options">
                          <h3>{{ t('sections.driverHighestFuelConsumption') }}</h3>
                          <div class="common-drop-down dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {{ t('sort.bestToWorst') }}
                              <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                              <li><a class="dropdown-item">{{ t('sort.bestToWorst') }}</a></li>
                              <li><a class="dropdown-item">{{ t('sort.worstToBest') }}</a></li>
                            </ul>
                          </div>
                        </div>
                      
                        <div class="main-table fuel-table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="vehicle">{{ t('table.vehicles') }}</th>
                                <th class="fuel-loss">
                                  {{ t('table.fuel') }} <br /> {{ t('table.consumptionKmL') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="last-month">
                                  {{ t('table.distance') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="driving-time">
                                  {{ t('table.drivingTime') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                              </tr>
                            </thead>
                      
                            <tbody>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 1 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 65%" aria-valuenow="65" aria-valuemin="0"
                                      aria-valuemax="100">
                                      1000
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 2 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0"
                                      aria-valuemax="100">
                                      800
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 3 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 57%" aria-valuenow="57" aria-valuemin="0"
                                      aria-valuemax="100">
                                      700
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 54%" aria-valuenow="54" aria-valuemin="0"
                                      aria-valuemax="100">
                                      600
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 49%" aria-valuenow="49" aria-valuemin="0"
                                      aria-valuemax="100">
                                      400
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      
                        <div class="table-btm-options">
                          <button class="common-button">{{ t('actions.viewAll') }}</button>
                        </div>
                      </div>
                </div>
                <div class="col-md-6 col-xs-12 performance_col">
                    <!-- <app-common-table [modalType]="'fuelConsumptionFour'" /> -->
                    <div class="performence-table">
                        <div class="d-flex align-items-center justify-content-between table-top-options">
                          <h3>{{ t('sections.mostImprovedVehicles') }}</h3>
                          <div class="common-drop-down dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {{ t('sort.bestToWorst') }}
                              <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                              <li><a class="dropdown-item">{{ t('sort.bestToWorst') }}</a></li>
                              <li><a class="dropdown-item">{{ t('sort.worstToBest') }}</a></li>
                            </ul>
                          </div>
                        </div>
                      
                        <div class="main-table fuel-table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="vehicle">{{ t('table.vehicles') }}</th>
                                <th class="fuel-loss">
                                  {{ t('table.fuel') }} <br /> {{ t('table.consumptionKmL') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="last-month">
                                  {{ t('table.distance') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="driving-time">
                                  {{ t('table.drivingTime') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                              </tr>
                            </thead>
                      
                            <tbody>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 1 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 65%" aria-valuenow="65"
                                      aria-valuemin="0" aria-valuemax="100">
                                      1000
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 2 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 60%" aria-valuenow="60"
                                      aria-valuemin="0" aria-valuemax="100">
                                      800
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 3 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 57%" aria-valuenow="57"
                                      aria-valuemin="0" aria-valuemax="100">
                                      700
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 54%" aria-valuenow="54"
                                      aria-valuemin="0" aria-valuemax="100">
                                      600
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 49%" aria-valuenow="49"
                                      aria-valuemin="0" aria-valuemax="100">
                                      400
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      
                        <div class="table-btm-options">
                          <button class="common-button">{{ t('actions.viewAll') }}</button>
                        </div>
                      </div>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
            <div class="row performance_row">
                <div class="col-md-6 col-xs-12 performance_col">
                    <!-- <app-common-table [modalType]="'fuelFillUpsOne'" /> -->
                    <div class="performence-table">
                        <div class="d-flex align-items-center justify-content-between table-top-options">
                          <h3>{{ t('sections.vehiclesHighestFuelFillUps') }}</h3>
                          <div class="common-drop-down dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {{ t('sort.bestToWorst') }}
                              <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                              <li><a class="dropdown-item">{{ t('sort.bestToWorst') }}</a></li>
                              <li><a class="dropdown-item">{{ t('sort.worstToBest') }}</a></li>
                            </ul>
                          </div>
                        </div>
                        <div class="main-table fuel-table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="vehicle">{{ t('table.vehicles') }}</th>
                                <th class="fuel-loss">
                                  {{ t('table.fuelLosses') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="last-month">
                                  {{ t('table.fromLastMonth') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="driving-time">
                                  {{ t('table.drivingTime') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 1 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 65%" aria-valuenow="65" aria-valuemin="0"
                                      aria-valuemax="100">
                                      1000
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 2 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0"
                                      aria-valuemax="100">
                                      800
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="decrease-txt">
                                    -4% <i><img src="assets/images-fuel/decreaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 3 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 57%" aria-valuenow="57" aria-valuemin="0"
                                      aria-valuemax="100">
                                      700
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="decrease-txt">
                                    -4% <i><img src="assets/images-fuel/decreaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 54%" aria-valuenow="54" aria-valuemin="0"
                                      aria-valuemax="100">
                                      600
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="decrease-txt">
                                    -4% <i><img src="assets/images-fuel/decreaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 49%" aria-valuenow="49" aria-valuemin="0"
                                      aria-valuemax="100">
                                      400
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="table-btm-options">
                          <button class="common-button">{{ t('actions.viewAll') }}</button>
                        </div>
                      </div>
                </div>
                <div class="col-md-6 col-xs-12 performance_col">
                    <!-- <app-common-table [modalType]="'fuelFillUpsTwo'" /> -->
                    <div class="performence-table">
                        <div class="d-flex align-items-center justify-content-between table-top-options">
                          <h3>{{ t('sections.locationHighestFuelFillUps') }}</h3>
                          <div class="common-drop-down dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {{ t('sort.bestToWorst') }}
                              <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                              <li><a class="dropdown-item">{{ t('sort.bestToWorst') }}</a></li>
                              <li><a class="dropdown-item">{{ t('sort.worstToBest') }}</a></li>
                            </ul>
                          </div>
                        </div>
                        <div class="main-table fuel-table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="vehicle">{{ t('table.vehicles') }}</th>
                                <th class="fuel-loss">
                                  {{ t('table.fuelLosses') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="last-month">
                                  {{ t('table.fromLastMonth') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="driving-time">
                                  {{ t('table.drivingTime') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 1 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 65%" aria-valuenow="65" aria-valuemin="0"
                                      aria-valuemax="100">
                                      1000
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 2 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0"
                                      aria-valuemax="100">
                                      800
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 3 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 57%" aria-valuenow="57" aria-valuemin="0"
                                      aria-valuemax="100">
                                      700
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 54%" aria-valuenow="54" aria-valuemin="0"
                                      aria-valuemax="100">
                                      600
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 49%" aria-valuenow="49" aria-valuemin="0"
                                      aria-valuemax="100">
                                      400
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="table-btm-options">
                          <button class="common-button">{{ t('actions.viewAll') }}</button>
                        </div>
                      </div>
                </div>
                <div class="col-md-6 col-xs-12 performance_col">
                    <!-- <app-common-table [modalType]="'fuelFillUpsThree'" /> -->
                    <div class="performence-table">
                        <div class="d-flex align-items-center justify-content-between table-top-options">
                          <h3>{{ t('sections.driverHighestFuelFillUps') }}</h3>
                          <div class="common-drop-down dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {{ t('sort.bestToWorst') }}
                              <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                              <li><a class="dropdown-item">{{ t('sort.bestToWorst') }}</a></li>
                              <li><a class="dropdown-item">{{ t('sort.worstToBest') }}</a></li>
                            </ul>
                          </div>
                        </div>
                        <div class="main-table fuel-table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="vehicle">{{ t('table.vehicles') }}</th>
                                <th class="fuel-loss">
                                  {{ t('table.fuelLosses') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="last-month">
                                  {{ t('table.fromLastMonth') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="driving-time">
                                  {{ t('table.drivingTime') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 1 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 65%" aria-valuenow="65" aria-valuemin="0"
                                      aria-valuemax="100">
                                      1000
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 2 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0"
                                      aria-valuemax="100">
                                      800
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 3 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 57%" aria-valuenow="57" aria-valuemin="0"
                                      aria-valuemax="100">
                                      700
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 54%" aria-valuenow="54" aria-valuemin="0"
                                      aria-valuemax="100">
                                      600
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 49%" aria-valuenow="49" aria-valuemin="0"
                                      aria-valuemax="100">
                                      400
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="table-btm-options">
                          <button class="common-button">{{ t('actions.viewAll') }}</button>
                        </div>
                      </div>
                </div>
                <div class="col-md-6 col-xs-12 performance_col">
                    <!-- <app-common-table [modalType]="'fuelFillUpsFour'" /> -->
                    <div class="performence-table">
                        <div class="d-flex align-items-center justify-content-between table-top-options">
                          <h3>{{ t('sections.mostImprovedVehicles') }}</h3>
                          <div class="common-drop-down dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              {{ t('sort.bestToWorst') }}
                              <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                              <li><a class="dropdown-item">{{ t('sort.bestToWorst') }}</a></li>
                              <li><a class="dropdown-item">{{ t('sort.worstToBest') }}</a></li>
                            </ul>
                          </div>
                        </div>
                        <div class="main-table fuel_table">
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="vehicle">{{ t('table.vehicles') }}</th>
                                <th class="fuel-loss">
                                  {{ t('table.fuelLosses') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="last-month">
                                  {{ t('table.fromLastMonth') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                                <th class="driving-time">
                                  {{ t('table.drivingTime') }}
                                  <!-- <button class="filter-button">
                                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                                  </button> -->
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 1 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 65%" aria-valuenow="65"
                                      aria-valuemin="0" aria-valuemax="100">
                                      1000
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 2 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 60%" aria-valuenow="60"
                                      aria-valuemin="0" aria-valuemax="100">
                                      800
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 3 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 57%" aria-valuenow="57"
                                      aria-valuemin="0" aria-valuemax="100">
                                      700
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 54%" aria-valuenow="54"
                                      aria-valuemin="0" aria-valuemax="100">
                                      600
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                              <tr>
                                <td class="vehicle">
                                  <p class="bold-text">{{ t('table.vehicleNumber', { number: 4 }) }}</p>
                                </td>
                                <td class="fuel-loss">
                                  <div class="progress">
                                    <div class="progress-bar increase" role="progressbar" style="width: 49%" aria-valuenow="49"
                                      aria-valuemin="0" aria-valuemax="100">
                                      400
                                    </div>
                                  </div>
                                </td>
                                <td class="last-month">
                                  <p class="increase-txt">
                                    20% <i><img src="assets/images-fuel/increaseImg.svg" /></i>
                                  </p>
                                </td>
                                <td class="driving-time">
                                  <p>24.3</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="table-btm-options">
                          <button class="common-button">{{ t('actions.viewAll') }}</button>
                        </div>
                      </div>
                </div>
            </div>
        </div>
    </div>
</div>
</ng-container>
